export default __webpack_public_path__ + "images/racion-stone-0.svg";